import { Component, OnInit } from '@angular/core';
import { ToastService } from '../../shared/components/toast/service/toast.service';
import { TrackService } from '../../shared/services/track/track.service';
import { Track } from '../../shared/models/interfaces/track.interface';
import { SpinnerComponent } from "../../shared/components/spinner/spinner.component";
import { TrackCardComponent } from '../../shared/components/track-card/track-card.component';
import { IconComponent } from '../../shared/components/icon/icon.component';
import { FormsModule } from '@angular/forms';

@Component({
  selector: 'l-tracks',
  imports: [SpinnerComponent, TrackCardComponent, IconComponent, FormsModule],
  templateUrl: './tracks.component.html',
})
export class TracksComponent implements OnInit {

  //#region Constructor

  constructor(
    private readonly trackService: TrackService,
    private readonly toastService: ToastService
  ) {}

  //#endregion


  //#region Public Properties

  public searchQuery: string = '';

  public selectedTracks: Track[] = [];

  public tracks: Track[] = [];

  public isLoading: boolean = false;

  //#endregion

  //#region Public Methods

  public async ngOnInit(): Promise<void> {
    await this.loadTracks();
  }

  public onSearchTermChange(term: string): void {
    this.searchQuery = term;
    this.loadTracks();
  }

  //#endregion

  //#region Private Methods

  private async loadTracks(): Promise<void> {
    try {
      this.isLoading = true;

      this.tracks = await this.trackService.search({ search: { name: { $contL: this.searchQuery } } });
    } catch (error) {
      this.toastService.error('Erro ao carregar as trilhas', 'Oops...');
    } finally {
      this.isLoading = false;
    }
  }

  //#endregion

}
